import { SportsbookConnection, SDQueryBuilder } from "./C_Sportsbook";
import { CaptorConnection } from "./C_Captor";
import { RealityCheckConnection } from "./C_RealityCheck";
import { SearchConnection } from "./C_Search";
import { BetslipConnection } from "./C_Betslip";
import { PlayerDataConnection } from "./C_PlayerData";
import { BetsReportingConnection } from "./C_BetsReporting";
import { CasinoConnection } from "./C_Casino";
import { OpenBetsQueryBuilder, OpenBetsConnection } from "./C_OpenBets";
import { OpenBetsRPCConnection } from "./C_OpenBetsRPC";
import { CasinoPlayerActivityConnection } from "./C_CasinoPlayerActivity";
import { TournamentsConnection } from "./C_Tournaments";
import { getProxyClass } from "./Common";
export const Sportsbook = {
    connection: SportsbookConnection,
    queryBuilder: SDQueryBuilder
};
export const OpenBets = {
    connection: OpenBetsConnection,
    queryBuilder: OpenBetsQueryBuilder
};
export const OpenBetsRPC = {
    connection: OpenBetsRPCConnection
};
export const Betslip = {
    connection: getProxyClass(BetslipConnection)
};
export const CaptorData = {
    connection: getProxyClass(CaptorConnection)
};
export const RealityCheck = {
    connection: getProxyClass(RealityCheckConnection)
};
export const SearchData = {
    connection: getProxyClass(SearchConnection)
};
export const TournamentsData = {
    connection: getProxyClass(TournamentsConnection)
};
export const BetsReporting = {
    connection: getProxyClass(BetsReportingConnection)
};
export const PlayerData = {
    connection: getProxyClass(PlayerDataConnection)
};
export const CasinoData = {
    connection: getProxyClass(CasinoConnection)
};
export const CasinoPlayerActivity = {
    connection: getProxyClass(CasinoPlayerActivityConnection)
};
export { init } from "./App";
if (process.env.NODE_ENV === "development") {
    const { demo } = require("./Examples");
    module.exports = Object.assign(Object.assign({}, module.exports), { demo });
}
//# sourceMappingURL=index.js.map